import { createClient } from '@oysterjs/corev2/graphql/client';
export const client = createClient('Agency');
